import { render } from "./CreateWizard.vue?vue&type=template&id=d7c0df2a&scoped=true"
import script from "./CreateWizard.vue?vue&type=script&lang=js"
export * from "./CreateWizard.vue?vue&type=script&lang=js"

import "./CreateWizard.vue?vue&type=style&index=0&id=d7c0df2a&scoped=true&lang=css"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7c0df2a"]])

export default __exports__